"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncompressFile = uncompressFile;

function uncompressFile(dataBuffer) {
  var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var dataView = new DataView(dataBuffer);
  var result = []; // copy uncompressed bytes before compression starts

  for (var i = 0; i < startOffset; i++) {
    result.push(dataView.getUint8(i));
  }

  var endOfChunk = startOffset;
  var offset = startOffset; // while a new chunk is found

  while (offset < dataView.byteLength && [0x4F, 0x4E].includes(dataView.getUint8(offset))) {
    var chunkType = dataView.getUint8(offset);
    endOfChunk += dataView.getUint16(offset + 1, true);
    offset += 9;

    if (chunkType === 0x4E) {
      // UncompressedChunk
      for (; offset < endOfChunk; offset++) {
        result.push(dataView.getUint8(offset));
      }

      continue;
    } // While the chunk is not finished


    while (offset < endOfChunk) {
      // read 32bit descritor indicating litterals(0) or length-distance pair(1)
      var descriptor = dataView.getUint32(offset, true);

      if (!(descriptor & 0x80000000)) {
        throw Error("Unexpected descriptor");
      }

      offset += 4;

      for (var _i = 0; _i < 31; _i++) {
        if (descriptor >> _i & 0x00000001) {
          // length-distance pair
          var length = void 0,
              distance = void 0;
          var firstByte = dataView.getUint8(offset);

          if ((firstByte & 0x03) === 0) {
            // one byte (distance (6bits) + 2bits)
            length = 3;
            distance = dataView.getUint8(offset) >> 2;
            offset++;
          } else if ((firstByte & 0x03) === 1) {
            // two bytes (distance (14bits)  + 2bits)
            length = 3;
            distance = dataView.getUint16(offset, true) >> 2;
            offset += 2;
          } else if ((firstByte & 0x03) === 2) {
            // two bytes (distance (10bits) + length (4bits) + 2bits)
            var pair = dataView.getUint16(offset, true);
            offset += 2;
            length = ((pair & 0x003C) >> 2) + 3;
            distance = pair >> 6;
          } else if ((firstByte & 0x7F) === 3) {
            // four bytes (distance (17bits) + length (8bits) + 7bits)
            var _pair = dataView.getUint32(offset, true);

            offset += 4;
            length = ((_pair & 0x7F80) >> 7) + 3;
            distance = _pair >> 15;
          } else {
            // three bytes (distance (17bits) + length (5bits) + 2bits)
            var _pair2 = dataView.getUint32(offset, true) & 0x00FFFFFF;

            offset += 3;
            length = ((_pair2 & 0x007C) >> 2) + 2;
            distance = _pair2 >> 7;
          } // copy repeated data to result


          for (var j = 0; j < length; j++) {
            result.push(result[result.length - distance]);
          }
        } else {
          // Literal byte
          result.push(dataView.getUint8(offset));
          offset++;
        }

        if (offset >= endOfChunk) {
          break;
        }
      }
    }
  }

  if (offset < dataView.byteLength) {
    console.log("End of compression: ".concat(dataView.getUint8(offset).toString(16)));
  } // The rest of the file is not compressed


  for (; offset < dataView.byteLength; offset++) {
    result.push(dataView.getUint8(offset));
  }

  return result;
}